import * as React from "react";
import { Icon } from "@blueprintjs/core";
import classNames from "classnames";

export enum QualityStatus {
  Passed,
  Failed,
  Caution,
  Missing,
}

export const QualityControlWrapper = ({ children }: { children?: React.ReactNode }) => {
  return <div className="quality-control">{children}</div>;
};

export const QualityControlSection = ({
  header,
  description,
  children,
}: {
  header: string;
  description?: React.ReactNode;
  children?: React.ReactNode;
}) => {
  return (
    <div className="quality-control__section">
      <h2>{header}</h2>
      {description ? <div className="quality-control__description">{description}</div> : null}
      {children}
    </div>
  );
};

export const QualityControlStatuses = ({ children }: { children?: React.ReactNode }) => {
  return <div className="quality-control__statuses">{children}</div>;
};

export const QualityControlStatusLine = ({
  name,
  status,
  value,
}: {
  name: React.ReactNode;
  status: QualityStatus;
  value: React.ReactNode;
}) => {
  return (
    <div className="quality-control__line">
      <QualityTag status={status} />
      <span className="quality-control__line__name">{name}</span>
      <span className="quality-control__line__result">{value}</span>
    </div>
  );
};

export const QualityTag = ({ status }: { status: QualityStatus }) => {
  const classes = classNames("quality-tag", {
    "quality-tag--passed": status === QualityStatus.Passed,
    "quality-tag--failed": status === QualityStatus.Failed,
    "quality-tag--caution": status === QualityStatus.Caution,
    "quality-tag--missing": status === QualityStatus.Missing,
  });
  return (
    <span className={classes}>
      {statusToTagIcon(status)}
      {statusToTagText(status)}
    </span>
  );
};

function statusToTagText(status: QualityStatus): string {
  switch (status) {
    case QualityStatus.Passed:
      return "Passed";
    case QualityStatus.Failed:
      return "Failed";
    case QualityStatus.Caution:
      return "Caution";
    case QualityStatus.Missing:
      return "Missing";
  }
}

function statusToTagIcon(status: QualityStatus): React.ReactNode {
  switch (status) {
    case QualityStatus.Passed:
      return <Icon icon="tick-circle" />;
    case QualityStatus.Failed:
      return <Icon icon="error" />;
    case QualityStatus.Caution:
      return <Icon icon="warning-sign" />;
    case QualityStatus.Missing:
      return <Icon icon="error" />;
  }
}
